import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {GetSettingsNotifications, SetSetting, UpdateSettingsNotifications} from 'entities/settings'
import {setSettingUser, useSound} from 'entities/user'
import {Toggle} from 'shared/ui/toggle'
import styles from './styles.module.scss'

export const Notifications = () => {
  const dispatch = useDispatch()
  const [settings, setSettings] = useState({
    messages: false,
    likes: false,
    visits: false,
    favorites: false,
    marketing: false
  })
  const isSound = useSound()

  const changeSound = () => {
    SetSetting('isAudioEnabled', !isSound)
      .then(() => dispatch(setSettingUser({key: 'isAudioEnabled', value: !isSound})))
      .catch(console.error)
  }

  useEffect(() => {
    GetSettingsNotifications()
      .then(({data}) => setSettings({...data}))
      .catch(console.error)
  }, [])

  const onClickHandler = (name: string, value: boolean) => {
    const newSetting = {...settings, [name]: value}

    setSettings(newSetting)
    UpdateSettingsNotifications(newSetting).catch(console.error)
  }

  const getTurnText = (isActive?: boolean) => isActive ? 'Turn on' : 'Turn off'

  return (
    <div className={styles.container}>
      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Sound notifications</div>
          <div className={styles.text}>{getTurnText(isSound)}</div>
        </div>
        <div className={styles.checkbox}>
          <Toggle value={isSound} onClick={changeSound} />
        </div>
      </div>

      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Email new message</div>
          <div className={styles.text}>{getTurnText(settings.messages)}</div>
        </div>
        <div className={styles.checkbox}>
          <Toggle
            value={settings.messages}
            onClick={() => onClickHandler('messages', !settings.messages)}
          />
        </div>
      </div>

      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Email someone likes you</div>
          <div className={styles.text}>{getTurnText(settings.likes)} </div>
        </div>
        <div className={styles.checkbox}>
          <Toggle
            value={settings.likes}
            onClick={() => onClickHandler('likes', !settings.likes)}
          />
        </div>
      </div>

      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Email visitors</div>
          <div className={styles.text}>{getTurnText(settings.visits)} </div>
        </div>
        <div className={styles.checkbox}>
          <Toggle
            value={settings.visits}
            onClick={() => onClickHandler('visits', !settings.visits)}
          />
        </div>
      </div>

      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Email add to favorite</div>
          <div className={styles.text}>{getTurnText(settings.favorites)} </div>
        </div>
        <div className={styles.checkbox}>
          <Toggle
            value={settings.favorites}
            onClick={() => onClickHandler('favorites', !settings.favorites)}
          />
        </div>
      </div>

      <div className={styles.element}>
        <div className={styles.info}>
          <div className={styles.name}>Email marketing</div>
          <div className={styles.text}>{getTurnText(settings.marketing)} </div>
        </div>
        <div className={styles.checkbox}>
          <Toggle
            value={settings.marketing}
            onClick={() => onClickHandler('marketing', !settings.marketing)}
          />
        </div>
      </div>
    </div>
  )
}
